import React from 'react';
import { useParams } from 'react-router-dom';
import { ErrorHandler } from '@/components/organisms/ErrorWrapper/ErrorHandler';

export const ErrorPage: React.FC = () => {
  const { errorType } = useParams<{ errorType: string }>();
  return <ErrorHandler errorType={errorType || 'default'} />;
};